// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Avatar } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
import AppCache from '../../../services/appcache';
// ---------------------------------------------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(2, 2.5),
    // borderRadius: Number(theme.shape.borderRadius) * 1.5,
    // backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));
// ---------------------------------------------------------------------------------------------------------

const userRoles = [
    { id: 1, name: 'Sales Manager' },
    { id: 2, name: 'Supervisor' },
    { id: 3, name: 'Field Staff' }
];
// ---------------------------------------------------------------------------------------------------------

export default function CoENavAccount() {

    const { user } = useAuthContext();
    const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userName = `${currentLoggedInUser.UserFirstName} ${currentLoggedInUser.UserLastName}` || currentLoggedInUser.UserName;

    return (
        <StyledRoot>
            {/* <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} />

      <Box sx={{ ml: 2, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.displayName}
        </Typography>

        <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
          {user?.role}
        </Typography>
      </Box> */}
            <Stack direction='column' justifyContent='space-between' flexGrow={1} sx={{ mx: 4, mt: 1, mb: 3 }}>
                <Avatar src={currentLoggedInUser.ProfileImage} alt="photoURL" />

                <Typography variant="subtitle2" sx={{ color: 'common.black' }}>
                    {userName}
                </Typography>

                <Typography variant="caption" sx={{ color: 'common.black' }}>
                    {currentLoggedInUser.UserRoleName} - ETHICON
                </Typography>
            </Stack>

        </StyledRoot>
    );
}
